import { queryOptions, useQuery } from '@tanstack/react-query'

import { api } from '@/lib/api-client'
import { QueryConfig } from '@/lib/react-query'
import { BillingRestrictionInfo } from '../billingRestriction'

export type AccountStore = {
	id: string
	accountId: string
	legalFFLName: string | null
	friendlyFFLName: string | null
	fflNumber: string | null
	fflFirstThreeDigits: string | null
	fflLastFiveDigits: string | null
	premiseStreet: string | null
	streetAddress2: string | null
	premiseCity: string | null
	premiseState: string | null
	premiseZipCode: string | null
	mailingStreet: string | null
	mailingCity: string | null
	mailingState: string | null
	mailingZipCode: string | null
	email: string | null
	phone: string | null
	varianceName: string | null
	auditStatus: string | number | null
	shouldDeleteDocumentsOnExpiration: boolean
	loaIssueDate: string | null
	loaExpirationDate: string | null
	expirationDate: string | null
	businessHours: string | null
	usersCount: number
	documentsCount: number
	isDisabled: boolean
	isDelinquent: boolean
	billingRestriction?: BillingRestrictionInfo | null
}

export const getAccountStores = (id: string): Promise<AccountStore[]> => {
	return api.get(`/accounts/${id}/stores`)
}

export const getAccountStoresQueryOptions = (accountId: string) => {
	return queryOptions({
		queryKey: ['accounts', accountId, 'stores'],
		queryFn: () => getAccountStores(accountId),
	})
}

type UseAccountStoresOptions = {
	accountId: string
	queryConfig?: QueryConfig<typeof getAccountStores>
}

export const useAccountStores = ({
	accountId,
	queryConfig,
}: UseAccountStoresOptions) => {
	return useQuery({
		...getAccountStoresQueryOptions(accountId),
		...queryConfig,
	})
}
